import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface BusinessDetails {
  id: string;
  name: string;
  company_logo: string | null;
  company_banner_url: string | null;
  city: string;
  postal_code: string;
  reviews: { rating: number }[];
}

interface UseBusinessesByIdsParams {
  businessIds: string[];
  enabled?: boolean;
}

export const useBusinessesByIds = ({ 
  businessIds, 
  enabled = true 
}: UseBusinessesByIdsParams) => {
  return useQuery<BusinessDetails[]>({
    queryKey: ['businessesByIds', businessIds],
    queryFn: async () => {
      if (!businessIds.length) return [];
      
      const { data: businesses, error } = await supabase
        .from('businesses')
        .select(`
          id,
          name,
          company_logo,
          company_banner_url,
          city,
          postal_code,
          reviews(rating)
        `)
        .in('id', businessIds);
        
      if (error) {
        console.error('Error fetching businesses by IDs:', error);
        throw error;
      }
      
      return businesses || [];
    },
    enabled: enabled && businessIds.length > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });
};